

/**
* Represents a function to convert data of type `ISelect` to array of strings.
* @function `useConvertSelectToArray`
* @param {object} data - The select data of type object of the book.
* @returns {array}  The select data of type array.
*/



export const convertSelectToArray = (data) => {


  if (data) {
    const extractedValues = data?.map((option) => option.value);
    return extractedValues;
  } else {
    console.info("Nothing selected yet");
    return [""];
  }

}



/**
 * Transforms an object of type IData into an array of strings (IReturnedData)
 * @param {IData} data - Array of objects containing `label` and `value`
 * @returns {IReturnedData} - Array of strings
 */
export function transformData(data) {
  if (!Array.isArray(data)) {
    console.error("Input must be an array of objects");
  }

  return data.map(item => {
    if (typeof item.label !== "string" || typeof item.value !== "string") {
      console.error("Each item must have 'label' and 'value' as strings");
    }
    return `${item.value}`;
  });
}

